module.exports = __webpack_public_path__ + "static/media/Second-Button.01c4fa41.png";